<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>课程统计报告</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div v-show="false"></div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
          <!-- <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div> -->
        </div>
      </div>
      <div id="list">
        <table class="stat-table">
          <tbody>
            <tr>
              <th>课程名称</th>
              <th>课程负责人</th>
              <th>开始时间</th>
              <th>结束时间</th>
              <th>选课人数</th>
              <th>结课率</th>
            </tr>
            <tr>
              <td>{{lessonInfo.title}}</td>
              <td>{{lessonInfo.manager_id?lessonInfo.manager.name:'-'}}</td>
              <td>{{$formatDate(lessonInfo.startTime)}}</td>
              <td>{{$formatDate(lessonInfo.endTime)}}</td>
              <td>{{ tableData ? tableData.studentCount : 0 }}</td>
              <td>{{ tableData ? tableData.studentFinishPercent : 0 }}%</td>
            </tr>
          </tbody>
        </table>
        <br>
        <table class="stat-table">
          <tbody>
            <tr>
              <th rowspan="2">课件数</th>
              <th rowspan="2">授课视频个数</th>
              <th rowspan="2">非视频资源数</th>
              <!--            <th colspan="3">作业和测验</th>-->
              <th colspan="3">测试</th>
              <th rowspan="2">成绩通过人数</th>
              <th rowspan="2">成绩通过比率</th>
              <th rowspan="2">最高分数</th>
              <!--            <th rowspan="2">课程公告数</th>-->
              <th colspan="4">互动交流情况</th>
            </tr>
            <tr>
              <!--            <th>次数</th>-->
              <!--            <th>习题总数</th>-->
              <!--            <th>参与人次</th>-->
              <th>次数</th>
              <th>试题总数</th>
              <th>参与人数</th>
              <th>发帖总数</th>
              <th>教师发帖（答疑）数</th>
              <th>参与互动学生数</th>
              <th>学生发帖总数</th>
            </tr>
            <tr>
              <td>{{ tableData ? tableData.studyCount : 0 }}</td>
              <td>{{ tableData ? tableData.studyVideoCount : 0 }}</td>
              <td>{{ tableData ? tableData.studyOtherCount : 0 }}</td>
              <!--            <td>{{ tableData ? tableData.homeworkCount + tableData.testCount : 0 }}</td>-->
              <!--            <td>{{ tableData ? tableData.testQuestionCount : 0 }}</td>-->
              <!--            <td>{{ tableData ? tableData.homeworkFinishCount + tableData.testFinishCount : 0 }}</td>-->
              <td>{{ tableData ? tableData.examCount : 0 }}</td>
              <td>{{ tableData ? tableData.examQuestionCount : 0 }}</td>
              <td>{{ tableData ? tableData.examStudentCount : 0 }}</td>
              <td>{{ tableData ? tableData.studentPassCount : 0 }}</td>
              <td>{{ tableData ? tableData.studentPassPercent : 0 }}%</td>
              <td>{{ tableData ? tableData.studentMaxGrade : 0 }}</td>
              <!--            <td>{{ tableData ? tableData.noticeCount : 0 }}</td>-->
              <td>{{ tableData ? tableData.allDiscuss : 0 }}</td>
              <td>{{ tableData ? tableData.teacherDiscuss : 0 }}</td>
              <td>{{ tableData ? tableData.joinDiscuss : 0 }}</td>
              <td>{{ tableData ? tableData.studentDiscuss : 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseStatistics',
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      queryInfo: {
        lessonOnlineId: this.$route.query.id
      },
      tableData: null
    }
  },
  methods: {
    async search() {
      await this.$http.get('/lesson_online_course_statistics/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.data
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    }
  },
  created() {
  },
  mounted() {
    this.search()
  },
  computed: {}
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
.fileName span {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
</style>
